import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const LargeBell = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M20.9547 16.67C19.7447 15.6 19.8247 13.91 19.8247 13.89C19.8247 13.88 19.8247 13.86 19.8247 13.85V9.91005C19.8247 5.71005 16.4247 2.30005 12.2447 2.30005C8.06469 2.30005 4.66469 5.72005 4.66469 9.92005V13.9C4.66469 13.9 4.73469 15.6 3.53469 16.68C3.31469 16.87 3.24469 17.18 3.34469 17.45C3.44469 17.72 3.70469 17.9 3.99469 17.9H20.4947C20.7847 17.9 21.0447 17.72 21.1447 17.45C21.2447 17.18 21.1747 16.87 20.9547 16.68V16.67Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M12.25 20.4444C11.6486 20.4444 11.1139 20.1547 10.777 19.7033H13.7226C13.3856 20.1544 12.851 20.4444 12.25 20.4444Z",
                    fill: "white",
                    stroke: "currentColor",
                    strokeWidth: "1.11111"
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.1324 13.8482V9.91048C19.1324 6.1088 16.0357 3 12.25 3C8.4643 3 5.36764 6.10995 5.36764 9.91048V13.8482C5.36764 13.8482 5.49081 15.8628 4 17.1868H20.5C19.0092 15.8628 19.1324 13.8482 19.1324 13.8482Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M12.25 20.4444C11.6486 20.4444 11.1139 20.1547 10.777 19.7033H13.7226C13.3856 20.1544 12.851 20.4444 12.25 20.4444Z",
                    fill: "white",
                    stroke: "currentColor",
                    strokeWidth: "1.11111"
                })
            ]
        })
    });
};

export { LargeBell as default };
